document.addEventListener('DOMContentLoaded', function() {
    // var kvinner_video_slider = new Swiper(".kvinner-video-slider", {
    //     spaceBetween: 24,
    //     loop: false,
    //     navigation: {
    //         prevEl: ".slider-prev",
    //         nextEl: ".slider-next",
    //     },
    //     pagination: {
    //         el: ".slider-dots",
    //         clickable: true,
    //     },
    //     breakpoints: {
    //         0: { slidesPerView: 1.05 },
    //         575: { slidesPerView: 1.7 },
    //         989: { slidesPerView: 2.5 },
    //         1200: { slidesPerView: 3 },
    //     },
    // });

    initBundleSlider();

    // Featued collection Slider

    var swiper_slider_product_grid = new Swiper(".swiper-slider-product-grid", {
      spaceBetween: 24,
      loop: false,
      navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
      },
      pagination: {
        el: ".slider-dots",
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 16},
        576: { slidesPerView: 1.5 },
        767: { slidesPerView: 2 },
        992: { slidesPerView: 2.5 },
        1025: { slidesPerView: 3 },
      },
    });

    var swiper_slider_product_grid = new Swiper(".swiper-slider-menu-grid", {
      spaceBetween: 24,
      loop: false,
      navigation: {
        prevEl: ".slider-prev",
        nextEl: ".slider-next",
      },
      pagination: {
        el: ".slider-dots",
        clickable: true,
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 16},
        575: { slidesPerView: 2 },
        769: { slidesPerView: 2.55 },
      },
    });

    // Init Swiper
    var gridProd_slider = new Swiper('.grid-products__carousel', {
      slidesPerView: 1,
      loop: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".slider-dots",
        clickable: true,
      },
    });

    const gridItems = document.querySelectorAll('.grid-product-item');
    gridItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        gridItems.forEach(el => el.classList.remove('active'));
        item.classList.add('active');
        gridProd_slider.slideTo(index + 1);
      });
    });
    gridProd_slider.on('slideChange', function () {
      const sliderIndex = gridProd_slider.activeIndex;
      const gridIndex = sliderIndex - 1;
      gridItems.forEach(el => el.classList.remove('active'));
      if (gridIndex < 0) return;
      if (gridItems[gridIndex]) {
        gridItems[gridIndex].classList.add('active');
      }
    });



});

let bundleKit = null;

function initBundleSlider() {
  const screenWidth = window.innerWidth;

  if (screenWidth < 992) {
    if (!bundleKit) {
      bundleKit = new Swiper(".bundle_kit_pro", {
        spaceBetween: 24,
        loop: false,
        navigation: {
          prevEl: ".slider-prev",
          nextEl: ".slider-next",
        },
        pagination: {
          el: ".slider-dots",
          clickable: true,
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          575: { slidesPerView: 1.5 },
          767: { slidesPerView: 2 }
        },
      });
    }
  } else {
    if (bundleKit) {
      bundleKit.destroy(true, true);
      bundleKit = null;
    }
  }
}

window.addEventListener("resize", initBundleSlider);
